// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sYwZl","delete":"styles_delete__3O0Hn","update":"styles_update__P2Gv0","add":"styles_add__3VYUh"};